import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'radar-echo-tops-legend-svg',
  templateUrl: './radar_echo_tops_legend.svg',
  styleUrl: '../../../../twc-legend/shared-legend-svg.css',
  standalone: true,
  imports: [CommonModule]
})
export class RadarEchoTopsSvgComponent {}
